import { createFileRoute } from '@tanstack/react-router';
import { CampaignPublishedPage } from '@/features/marketing';

/** Post-publish confirmation — `/marketing/campaigns/{id}/published`. */
export const Route = createFileRoute('/_auth/$orgId/marketing/campaigns_/$campaignId_/published')({
  component: CampaignPublishedRoute,
});

function CampaignPublishedRoute() {
  const { orgId, campaignId } = Route.useParams();
  return <CampaignPublishedPage orgId={orgId} campaignId={campaignId} />;
}
